/* oxlint-disable react/refs -- imperative refs are required for DOM, focus, drag, and media behavior */
'use client'

import { MagnifyingGlassIcon } from '@heroicons/react/24/outline'
import { XmarkCircleSolid } from 'iconoir-react'
import { ReactElement, useRef, useImperativeHandle, type Ref } from 'react'

type Props = {
  handleSearchValueChange?: (value: string) => void
  onClearSearch?: () => void
  ref?: Ref<HTMLInputElement>
}

export function ComboInputSearch({ handleSearchValueChange, onClearSearch, ref }: Props) {
  const inputRef = useRef<HTMLInputElement>(null)
  useImperativeHandle(ref, () => inputRef.current!)

  return (
    <div className="relative -order-3 border-b border-default">
      <input
        data-testid="combo-input"
        autoComplete="off"
        className="combobox-input"
        placeholder="Type to search"
        ref={inputRef}
        onChange={(event) => handleSearchValueChange?.(event.target.value)}
        autoFocus
      />
      {inputRef.current?.value && (
        <div className="stuff-on-the-right absolute inset-y-0 right-2 flex items-center rounded-r-md">
          <XmarkCircleSolid
            className="chevron chevron-icon block text-minimal"
            onClick={(evt) => {
              evt.stopPropagation()
              if (inputRef.current) {
                inputRef.current.value = ``
                inputRef.current.focus()
              }
              onClearSearch?.()
            }}
          />
        </div>
      )}
      <span className="absolute inset-y-0 left-0 flex items-center pl-4">
        <MagnifyingGlassIcon className="h-4 w-4" />
      </span>
    </div>
  )
}
